import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Suppress ResizeObserver errors (common with Monaco Editor)
const resizeObserverErrorHandler = (e: ErrorEvent) => {
	if (
		e.message ===
		"ResizeObserver loop completed with undelivered notifications."
	) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	}
	return true;
};

window.addEventListener("error", resizeObserverErrorHandler);

// Also handle unhandled promise rejections related to ResizeObserver
window.addEventListener("unhandledrejection", (e) => {
	if (e.reason?.message?.includes("ResizeObserver")) {
		e.preventDefault();
	}
});

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

// Console messages
console.log("pyBlaze - Visual Python Code Execution");
